export default "__VITE_ASSET__iBfVSNV7__"